module.exports = __webpack_public_path__ + "img/198.3bfcff4e.png";